import { postRequest, getRequest, putRequest } from "../../config/axiosConfig";

export const createEmployeePermissionById = async ({ payload }) => {
  try {

    const response = await postRequest({
      url: process.env.REACT_APP_BASE_URL + "permission/create-employee-permission",
      data: {
        employee_id: payload.employee_id,
        dashboard: payload.dashboard,
        system: payload.system

      },
    });

    if (response?.status === 200) {
      return {
        success: true,
        data: response,
        message: "Employee Permission Alter",
      };
    }
    return {
      success: false,
      data: response,
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid Employee Id.",
    };
  }
};

export const getEmployeePermissionById = async ({ id }) => {
  try {

    const response = await postRequest({
      url: process.env.REACT_APP_BASE_URL + "permission/get-employee-permission-by-id",
      data: {
        employee_id: id,
      },
    });

    if (response?.status === 200) {
      return {
        success: true,
        data: response,
        message: "Employee Permission fetch",
      };
    }
    return {
      success: false,
      data: response,
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid Employee Id.",
    };
  }
};


export const getAllEmployeePermission = async ({ page, limit }) => {
  try {

    const response = await getRequest({
      url: process.env.REACT_APP_BASE_URL + `permission/get-all-employee-permission?page=${page}&limit=${limit}`,
    });

    if (response?.status === 200) {
      return {
        success: true,
        data: response,
        message: "Get All Employee Permission",
      };
    }
    return {
      success: false,
      data: response,
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Unable to get permission",
    };
  }
};

export const updateEmployeePermissionById = async ({ payload }) => {
  try {

    const response = await putRequest({
      url: process.env.REACT_APP_BASE_URL + "permission/update-employee-permission",
      data: {
        employee_id: payload.employee_id,
        dashboard: payload.dashboard,
        system: payload.system

      },
    });

    if (response?.status === 200) {
      return {
        success: true,
        data: response,
        message: "Employee Permission Update",
      };
    }
    return {
      success: false,
      data: response,
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid Employee Id.",
    };
  }
}